import React, { useEffect } from 'react';
import { useOutlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { modeSet } from '../../store/filterSlice';
import EventList from '../events/EventList';
import './Content.css';

const Content = () => {
    const outlet = useOutlet();
    const dispatch = useDispatch();
    // Если смотрим приложение на узком экране,
    // то ставим по-умолчанию режим отображения
    // списком.
    useEffect(() => {
        if(window.innerWidth < 500) {
            dispatch(modeSet('list'));
        }
    }, [ dispatch ]);

	return (
        <div className='Content'>
            {outlet ? outlet : <EventList/>}
        </div>

    );
};

export default Content;
